import React from 'react';

export function BetAhead() {
  return (
    <>
      <svg width="12" height="25" viewBox="0 0 12 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M7.92377 9.85089H10.4669L3.24404 22.3442L4.56473 13.3804L4.64913 12.8075H4.07007H1.12521L3.70536 1.35803H10.7469L7.46296 9.15684L7.1707 9.85089H7.92377Z"
          stroke="#5A5E61"
        />
      </svg>
      Bet Ahead
    </>
  );
}
